// extracted by mini-css-extract-plugin
module.exports = {"root":"ContentList_root__m_lXi"};